import BaseService from '../../BaseService.js';

export default class GesuchService extends BaseService {
  constructor() {
    super(`gesuche`)
  }
}
